var $ = require('jquery');

let shareContainer;
let postTitle;
let featuredImage;
let relatedPosts;
let initialPointOfShow;
let relatedPostPos;

$(window).on('load', function() {
    if ( $('.single').length ) {
        shareContainer = $('.single').find('.post__share');
        postTitle = $('.single').find('.post__header');
        featuredImage = $('.single').find('.post__featured-visual');
        relatedPosts = $('.single').find('.post__related-posts');
        initialPointOfShow = 0;
        relatedPostPos = relatedPosts.offset().top;

        if ( featuredImage.length )  {
            initialPointOfShow = featuredImage.offset().top + featuredImage.height();
        } else {
            initialPointOfShow = postTitle.offset().top;
        }
    }
    

    
    $(window).on('scroll', function() {
        if ( $('.single').length ) { 
            console.log($(window).scrollTop() + (window.innerHeight / 2), relatedPostPos);
            if ( $(window).scrollTop() <= initialPointOfShow || $(window).scrollTop() + (window.innerHeight / 2) >= relatedPostPos ) {
                shareContainer.removeClass('animate-in');
            } else if ( $(window).scrollTop() > initialPointOfShow && $(window).scrollTop() + (window.innerHeight / 2) < relatedPostPos ) {
                shareContainer.addClass('animate-in');
            }
        }
    })
})



